import PropTypes from 'prop-types'

const ExchangeExplanatoryModal = ({ description }) => {
  return (
    <div className="bg-white font-semibold text-xl w-full py-6 text-candy-pink text-center">
      {description}
    </div>
  )
}

ExchangeExplanatoryModal.propTypes = {
  description: PropTypes.string
}

export default ExchangeExplanatoryModal
